export class EventArgs {
    constructor(source) {
        this._source = source;
    }
    get source() {
        return this._source;
    }
}
export class PropertyChangedEventArgs extends EventArgs {
    constructor(source, oldValue, newValue, propertyName) {
        super(source);
        this._propertyName = propertyName;
        this._oldValue = oldValue;
        this._newValue = newValue;
    }
    get propertyName() {
        return this._propertyName;
    }
    get oldValue() {
        return this._oldValue;
    }
    get newValue() {
        return this._newValue;
    }
    get source() {
        return this._source;
    }
}
//# sourceMappingURL=events.args.js.map